// Entry point for the CV Word (.docx) export.
//
// Mirror of ResumePdf.jsx: it inspects the resume properties and dispatches to
// the matching variant builder (common / cssf / europass). Unlike the PDF
// renderer (which returns a React element), this returns a `docx` Document that
// the caller serialises with Packer.toBlob(...).
//
// Async because the variant builders fetch logo assets for the header/footer.
//
// Status: all three variants implemented (common / cssf / europass).

import { extractResumeProperties } from "../../hooks/useResumeProperties";
import { buildCommonWord } from "./common/buildCommonWord";
import { buildCssfWord } from "./cssf/buildCssfWord";
import { buildEuropassWord } from "./europass/buildEuropassWord";

function resolveVariant( resumeData ) {
    const { isEuropass, isCssf } = extractResumeProperties( resumeData );
    if ( isEuropass ) {
        return "europass";
    }
    if ( isCssf ) {
        return "cssf";
    }
    return "common";
}

export async function buildResumeWordDocument( resumeData, translations ) {
    const variant = resolveVariant( resumeData );

    if ( variant === "europass" ) {
        return buildEuropassWord( resumeData, translations );
    }
    if ( variant === "cssf" ) {
        return buildCssfWord( resumeData, translations );
    }
    return buildCommonWord( resumeData, translations );
}
